import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import useActiveItem from "./useActiveItem";
import { useState } from "react";
import { clearCraftBlocks, setCraftBlocks } from "store/crafting";
import { getMatches } from "services/craftIdentityService";
import useEffectOnce from "./useEffectOnce";
import { nextIdentityStep } from "utils/crafting";
import { useSoundPath } from "./useSoundPath";
import useProfile from "./useProfile";

const useCraftIdentity = () => {
  const { search } = useLocation();
  const { token } = useProfile();
  const craftBlocks = useSelector((state) => state.crafting.identity);
  const {refreshTrigger} = useSelector((state) => state.cards)
  const dispatch = useDispatch();
  const {activeItem} = useActiveItem();
  const [firstSelectedCard, setFirstSelectedCard] = useState(null);
  const [activeBlock, setActiveBlock] = useState('');
  const [matchesLink, setMatchesLink] = useState('');
  const [matches, setMatches] = useState([])
  const [isMatchesLoading, setIsMatchesLoading] = useState(false);
  const [queryParams, setQueryParams] = useState(new URLSearchParams());
  const [selectCards, setSelectCards] = useState([]);
  const [filters, setFilters] = useState([]);
  const [activeFilters, setActiveFilters] = useState([]);
  const [selectedName, setSelectedName] = useState({});
  const resetCards = () => setSelectCards([]);
  const [paginationData, setPaginationData] = useState({});
  const [offsetCount, setOffsetCount] = useState(0);
  const [mode, setMode] = useState('select');
  const [marketCards, setMarketCards] = useState([]);
  const playSound = useSoundPath();

  const nextStep = () => {
    nextIdentityStep(activeBlock, setActiveBlock);
    setOffsetCount(0);
  }

  const parseQueryStringToObject = (queryString) => {
    const params = new URLSearchParams(queryString);
    return Object.fromEntries(params.entries());
  };

  useEffectOnce(() => {
    const params = new URLSearchParams(search);

    if (params.has('activeBlock')) {
      try {
        const blockValue = params.get('activeBlock');
        setActiveBlock(blockValue);
        const decodedSearch = decodeURIComponent(search.slice(1));
        const queryParamsObject = parseQueryStringToObject(decodedSearch);
        const {activeBlock, activeTag, cardRarity, type} = queryParamsObject
        const card = JSON.parse(queryParamsObject.card);
        setFirstSelectedCard({type: card.type, id: card.id})
        dispatch(setCraftBlocks({activeBlock, activeTag, cardRarity, type, card}));
        getMatches(card.name, activeBlock, setIsMatchesLoading, queryParams, setMatches, setQueryParams, card.id);
        nextIdentityStep(activeBlock, setActiveBlock);
      } catch (error) {
        console.log(error);
      }

    } else {
      dispatch(clearCraftBlocks('identity'))
      setActiveBlock('Category');
    }
  });

  return {
    search,  token, craftBlocks, refreshTrigger, dispatch, activeItem, firstSelectedCard, setFirstSelectedCard, activeBlock, setActiveBlock, matchesLink, setMatchesLink, matches, setMatches, isMatchesLoading, setIsMatchesLoading,
    queryParams, setQueryParams, selectCards, setSelectCards, filters, setFilters, activeFilters, setActiveFilters, selectedName, setSelectedName,
    resetCards, paginationData, setPaginationData, offsetCount, setOffsetCount, mode, setMode, marketCards, setMarketCards, nextStep, playSound
  }
}

export default useCraftIdentity;
